import React from "react";
import { Modal } from "antd";

const ModalComponent = ({title, children, visible, onOk, onCancel, width, ...others}) => {
  return (
    <Modal
      title={title}
      centered
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={width}
      footer={null}
      {...others}
    >
      {children}
    </Modal>
  );
};

export default ModalComponent;